import BootcampSuperBadge from '~/shared/components/BootcampSuperBadge'
import { CHAMPIONSHIP_IDS, COLLECTION_LIST, QUIZ_SUBJECT } from '~/types/homebaseQuiz.types'
import { EventAction } from '~/utils/analytics/events'
import { Breakpoint, useBreakpoint } from '~/utils'

import { BadgeData, SubBadges } from '../type'

import ExpandButton from './ExpandButton'

export default function SuperBadgeItem({
  superBadge,
  CollectionItemsSize,
  onClickTrophy,
}: {
  superBadge: BadgeData
  CollectionItemsSize: string
  onClickTrophy: ({
    subject,
    action,
    category,
    collection,
    badge,
  }: {
    subject: QUIZ_SUBJECT | CHAMPIONSHIP_IDS | string
    action: EventAction
    category?: string
    collection: COLLECTION_LIST
    badge?: BadgeData
  }) => void
}): React.ReactElement {
  const superBadgeData = superBadge.metadata
  const isUnlocked = superBadge.subBadges.filter((subBadge: SubBadges) => subBadge.isComplete).length
  const unlockedClassName = isUnlocked ? 'hover:cursor-pointer' : 'opacity-20'
  const br = useBreakpoint()
  const badgeHeight = br < Breakpoint.MD ? 40 : 80

  const badgePartImages = superBadge.subBadges.map((subBadge) => {
    return {
      bossDefeated: subBadge.isComplete,
      srcKey: subBadge.mainBadgeImagePartPath,
      bootcampNumber: String(subBadge.order),
      id: subBadge.featureId,
    }
  })

  const onItemClick = (): void => {
    if (isUnlocked) {
      onClickTrophy({
        subject: superBadgeData.subjectId,
        action: EventAction.CLICK_BOOTCAMP_BADGE,
        category: superBadgeData.gymCategory,
        collection: COLLECTION_LIST.BOOTCAMP,
        badge: superBadge,
      })
    }
  }

  return (
    <>
      {superBadge.imageOutlinePath && (
        <div
          className={`bg-white rounded px-1 py-0.5 mb-auto ${unlockedClassName}`}
          key={superBadge.featureId}
          onClick={onItemClick}
        >
          <div className={CollectionItemsSize}>
            <BootcampSuperBadge
              badgeHeight={badgeHeight}
              badgePartImages={badgePartImages}
              className="m-auto"
              imageMediaQuery={[{ screen: '(min-width: 280px)', width: '40rem' }]}
              outlineBadgeImage={{ srcKey: superBadge.imageOutlinePath }}
              partBadgeClass="w-full"
            />
            <ExpandButton disabled={!isUnlocked} />
          </div>
        </div>
      )}
    </>
  )
}
